import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { useFormatMessage } from 'src/providers/intl'
import { QUESTIONS } from 'src/constants/messages'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import {
  selectHasMortgageCoach,
  selectCustomerHasSponsor
} from 'src/store/selectors/customerProfile'
import {
  selectContactFirstName,
  selectContactPhone
} from 'src/store/selectors/contact'
import { Button, If, Unless } from 'src/Components'
import { IconPhone } from 'src/Components/shared/Icon'
import Questions from 'src/Components/shared/Questions/QuestionsContainer'
import MortgageCoachRequest from 'src/Components/shared/InterestSection/MortgageCoach/MortgageCoachRequest'
import RefiRequestButton from './RequestButton'

import styles from './RefiDetailsOverlay.module.scss'

const propTypes = {
  type: PropTypes.string,
  years: PropTypes.number,
  term: PropTypes.number,
  rate: PropTypes.number,
  apr: PropTypes.number,
  yearsInHome: PropTypes.number
}

const RefiDetailsFooter = details => {
  const { type, years, term, rate } = details

  const intlFormat = useFormatMessage()

  const hasSponsor = useSelector(selectCustomerHasSponsor)
  const hasMortgageCoach = useSelector(selectHasMortgageCoach)
  const contactFirstName = useSelector(selectContactFirstName)
  const contactPhone = useSelector(selectContactPhone)

  return (
    <div className={styles.footer}>
      <Questions
        trackActivityForCospo
        location='RefiDetailsModal'
        questionTopic='Refinancing'
        questions={[
          { question: intlFormat(QUESTIONS.refinanceRate) },
          { question: intlFormat(QUESTIONS.refinanceFees) },
          { placeholder: intlFormat(QUESTIONS.placeholder) }
        ]}
      >
        <div className={styles.questionsContent}>
          <If condition={hasSponsor}>
            <If condition={hasMortgageCoach}>
              <MortgageCoachRequest
                className={styles.buttonInQuestions}
                type={type}
                years={years}
                term={term}
                rate={rate}
                contactName={contactFirstName}
                rootMatchPath={OVERLAY_HELPERS.refinance.matchPath}
              />
            </If>
            <Unless condition={hasMortgageCoach}>
              <RefiRequestButton
                className={styles.buttonInQuestions}
                type={type}
                years={years}
              />
            </Unless>
          </If>
          <Button
            className={styles.callButton}
            iconStart={IconPhone}
            element='a'
            href={`tel:${contactPhone}`}
            track='RefiDetailsCall'
          >
            <FormattedMessage
              id='RefiDetailsModal.questions.call'
              defaultMessage='Call {name}'
              values={{
                name: contactFirstName
              }}
            />
          </Button>
        </div>
      </Questions>
    </div>
  )
}

RefiDetailsFooter.propTypes = propTypes

export default RefiDetailsFooter
